import { FC } from "react";
import { Loader2 } from "lucide-react";
import { Navigate } from "react-router";
import { useOrgRole } from "../hooks/useOrgRole";

interface EditorOnlyRouteProps {
  children: React.ReactNode;
  /** When provided, overrides the default canEdit check. */
  canAccess?: boolean;
}

const EditorOnlyRoute: FC<EditorOnlyRouteProps> = ({ children, canAccess }) => {
  const { canEdit, isRoleResolving } = useOrgRole();
  const hasAccess = canAccess !== undefined ? canAccess : canEdit;

  if (isRoleResolving) {
    return (
      <div
        className="flex min-h-[50vh] flex-col items-center justify-center gap-3"
        aria-label="Loading permissions"
      >
        <Loader2 className="h-8 w-8 animate-spin text-blue-400" />
        <span className="text-sm text-slate-400">Verifying access…</span>
      </div>
    );
  }

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default EditorOnlyRoute;
